const WORKSPACE_STATUSES = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',

};

export default WORKSPACE_STATUSES;